import React from 'react';
import IndexSummary from '../../common/index-summary';

const RED = `#eb505a`;
const GREEN = `#00de8b`;
const YELLOW = `#facc5c`;

class PriceInfo extends React.Component {
  getColor = (value, flag) => {
    if (value > flag) return GREEN;
    if (value < flag) return RED;
    return YELLOW;
  };

  render() {
    const { indexData } = this.props;

    const data = {
      MatchPrice:
        indexData === null || typeof indexData === 'undefined'
          ? 0
          : indexData.matchPrice,
      PriceChange:
        indexData === null || typeof indexData === 'undefined'
          ? 0
          : indexData.priceChange,
      PercentPriceChange:
        indexData === null || typeof indexData === 'undefined'
          ? 0
          : indexData.percentPriceChange,
      ReferencePrice:
        indexData === null || typeof indexData === 'undefined'
          ? 0
          : indexData.referencePrice,
      CeilingPrice:
        indexData === null || typeof indexData === 'undefined'
          ? 0
          : indexData.ceilingPrice,
      FloorPrice:
        indexData === null || typeof indexData === 'undefined'
          ? 0
          : indexData.floorPrice,
      tradingDate:
        indexData === null || typeof indexData === 'undefined'
          ? ''
          : indexData.tradingDate,
    };
    return <IndexSummary topContent={data} />;
  }
}

PriceInfo.defaultProps = {
  data: {
    MatchPrice: 0,
    PriceChange: 0,
    PercentPriceChange: 0,
    ReferencePrice: 0,
  },
};

export default PriceInfo;
